module.exports = __webpack_public_path__ + "static/media/bf11.8f2d1f31.png";